import { Observable, combineLatest } from 'rxjs'
import { startWith, first, map } from 'rxjs/operators'

/**
 * Creates an observable that emits a marker every time it's time to refresh the online status of
 * a user.
 *
 * @param onlineStatusBeingObserved$ observable for whether the online status is being observed.
 * @param statusChangesForUser$ should emit a value whenever a status change has been observed.
 * @returns an Observable that emits a marker every time it's time to refresh the online status.
 */
export function RefreshOnlineStatusStream(
  onlineStatusBeingObserved$: Observable<boolean>,
  statusChangesForUser$: Observable<unknown>,
): Observable<unknown> {
  return combineLatest([
    onlineStatusBeingObserved$.pipe(first(Boolean)),
    statusChangesForUser$.pipe(startWith(undefined)),
  ]).pipe(map(() => undefined))
}
